import { Dispatch, useState } from 'react';
import { ModalWrap } from '../../../component/modal-wrap';
import { deleteGame } from '../../../../api';
import { useDispatch, useSelector } from 'react-redux';
import {
  GamesAction,
  ReduxGamesActionType,
} from '../../../../store/modules/games';
import { IRootState } from '../../../../store/reducers';
import { useHistory } from 'react-router-dom';
import { IAPIGameItem, IAuditItem } from '../../../../model/api-modules';
import warnImage from '../../../../assets/images/warn-yellow.png';
import { messageSuccess } from '../../../../components/message';
import getFormatMessage from '../../../../locales/get-format-message';
import { auditWriteLog } from '../../../lib/aduit-log';

interface IProps {
  readonly selectedGame?: IAPIGameItem;
  readonly onClose: () => void;
  readonly studioID: string;
}

export const DeleteGameModal = (props: IProps) => {
  const history = useHistory();
  const games = useSelector((state: IRootState) => state.games.games);
  const gamesDispatch = useDispatch<Dispatch<GamesAction>>();
  const [loading, setLoading] = useState<boolean>(false);

  const onDel = async () => {
    let isDelete = false;
    setLoading(true);
    const { selectedGame, onClose } = props;

    if (selectedGame?.gameID) {
      isDelete = await deleteGame(selectedGame?.gameID);
      auditWriteLog(IAuditItem.DeleteGameTitle, {
        gameID: selectedGame?.gameID,
        detail: {
          gameID: selectedGame?.gameID,
        },
      });
    }
    if (isDelete) {
      // 删除store里对应的游戏
      const newGames = games.slice();
      const index = newGames.findIndex(
        (v) => v.gameID === selectedGame?.gameID
      );
      if (index !== -1) {
        newGames.splice(index, 1);
      }
      gamesDispatch({
        type: ReduxGamesActionType.GET_GAMES,
        result: newGames,
      });
      messageSuccess(
        getFormatMessage('game_deleted_success_message', {
          params: {
            gameName: selectedGame?.gameName,
          },
        })
      );
      history.replace(`/studio/${props.studioID}/portal`);
      onClose();
    }
    setLoading(false);
    return isDelete;
  };

  return (
    <div>
      <ModalWrap
        className="delete-game-modal delete-modal"
        width="455px"
        loading={loading}
        onOk={onDel}
        cancelText={getFormatMessage('cancel')}
        oKText={getFormatMessage('delete_title')}
        onClose={props.onClose}
        title={
          <p className="fail-title">
            <img
              src={warnImage}
              alt="Warning"
              style={{ marginRight: '10px', marginTop: '-2px' }}
            />
            <span>{getFormatMessage('delete_title')}</span>
          </p>
        }
      >
        <div>
          {getFormatMessage('sure_del_title_desc')}
          {props.selectedGame?.gameName}?
        </div>
        <div className="remove-text">
          {getFormatMessage('sure_del_title_permanently_desc')}
        </div>
      </ModalWrap>
    </div>
  );
};
